// extracted by mini-css-extract-plugin
export var button = "button-module--button--9ad72";
export var buttonWrapper = "button-module--buttonWrapper--662ad";
export var large = "button-module--large--ca768";
export var medium = "button-module--medium--d22ec";
export var primary = "button-module--primary--05a0e";
export var secondary = "button-module--secondary--5068f";
export var small = "button-module--small--f0f14";